import client from '@stores/apollo'
import gql from 'graphql-tag'
import { AssignmentPlanFragment } from '@api/fragments'
import { IAssignmentPlan } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface DeleteAssignmentPlanMutationInput {
  id: string
}

interface IPayload {
  deleteAssignmentPlan: {
    assignmentPlan: IAssignmentPlan
  }
}

const mutateHandler = handleFetchResult<IPayload, IAssignmentPlan>({
  handler: (data) => data.deleteAssignmentPlan.assignmentPlan,
  name: 'Assignment Plan',
})

export default function remove(input: DeleteAssignmentPlanMutationInput): Promise<IAssignmentPlan> {
  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation DeleteAssignmentPlan($input: DeleteAssignmentPlanMutationInput!) {
    deleteAssignmentPlan(input: $input) {
      assignmentPlan {
        ...AssignmentPlanFragment
      }
    }
  }
  ${AssignmentPlanFragment}
`
